import React from 'react';
import { ShieldCheckIcon, LockIcon, CheckCircleIcon } from './Icons';

export default function Safety() {
  const safetyPillars = [
    {
      title: 'Zero Advertising, Period',
      desc: 'Young children cannot distinguish ads from game content. We never include banner ads, interstitial popups, or rewarded video commercials.',
      badge: 'Ad-Free Guarantee',
      icon: '🚫'
    },
    {
      title: 'Complete Offline Privacy',
      desc: 'No account registration, no passwords, no email harvesting, and no cloud data tracking. Progress lives only on your personal device.',
      badge: 'Zero Data Harvesting',
      icon: '🔒'
    },
    {
      title: 'Gated Parent Controls',
      desc: 'Sound volume, screen brightness, reset options, and educator guides are safely locked behind an interactive parent multiplication gate.',
      badge: 'Parent-Controlled',
      icon: '🛡️'
    },
    {
      title: 'Gentle Sensory Pacing',
      desc: 'No flashing gambling-style slot mechanics, infinite streak pressures, or buzzer alarm sounds that cause digital overstimulation.',
      badge: 'Calm Learning',
      icon: '🧘'
    }
  ];

  return (
    <section id="safety" className="py-16 lg:py-24 bg-gradient-to-b from-white via-sky-50/50 to-white relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto space-y-3 mb-16">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-emerald-100 text-emerald-800 font-heading font-bold text-xs uppercase tracking-wider">
            <ShieldCheckIcon className="w-4 h-4 text-emerald-600" />
            <span>Parent Peace of Mind</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-black text-slate-900 tracking-tight">
            Our Uncompromising Child Safety Pledge
          </h2>
          <p className="text-slate-600 font-medium text-base sm:text-lg">
            As educators and parents, we built Kiki &amp; Kids to be the digital playground we trust with our own children.
          </p>
        </div>

        {/* 4 Safety Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {safetyPillars.map((p, idx) => (
            <div
              key={idx}
              className="rounded-3xl bg-white border-2 border-slate-200/90 p-7 shadow-md flex items-start gap-5 hover:border-kiki-blue transition-all"
            >
              <div className="text-4xl p-3 bg-sky-50 rounded-2xl flex-shrink-0">
                {p.icon}
              </div>
              <div className="space-y-2">
                <span className="text-[11px] font-heading font-bold px-2.5 py-0.5 rounded-full bg-emerald-50 text-emerald-800 border border-emerald-200">
                  {p.badge}
                </span>
                <h3 className="text-xl font-heading font-bold text-slate-900">
                  {p.title}
                </h3>
                <p className="text-xs sm:text-sm text-slate-600 font-medium leading-relaxed">
                  {p.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Sleeping Kiki Screen Time Feature */}
        <div className="mt-16 max-w-3xl mx-auto rounded-3xl bg-slate-900 text-white p-6 sm:p-8 shadow-2xl flex flex-col sm:flex-row items-center gap-6">
          <div className="w-28 h-28 rounded-2xl bg-slate-800 p-2 flex items-center justify-center flex-shrink-0">
            <img src="/assets/images/kiki-sleep.png" alt="Sleeping Miss Kiki" className="max-h-full object-contain" />
          </div>
          <div className="space-y-2 text-center sm:text-left">
            <span className="text-xs font-heading font-bold text-kiki-yellow uppercase tracking-wider">
              Healthy Screen Time Habit
            </span>
            <h4 className="font-heading font-black text-xl text-white">
              The Sleeping Miss Kiki Break Screen
            </h4>
            <p className="text-xs sm:text-sm text-slate-300 font-medium leading-relaxed">
              When the family play limit is reached, Miss Kiki tucks herself into bed with stars twinkling softly. Kids naturally recognize that Miss Kiki is resting, making screen transitions peaceful without tears.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
